import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./Feedback.css";

const FeedbackPage = () => {
  const { authData } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [city, setCity] = useState("");
  const [streamOfEngineering, setStreamOfEngineering] = useState("");
  const [feedback, setFeedback] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (
      !name.trim() ||
      !collegeName.trim() ||
      !city.trim() ||
      !streamOfEngineering.trim() ||
      !feedback.trim()
    ) {
      setError("Please fill in all required fields.");
      return;
    }
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/api/feedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authData.token}`,
          },
          body: JSON.stringify({
            name,
            collegeName,
            companyName,
            city,
            streamOfEngineering,
            feedback,
          }),
        }
      );
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError("Failed to submit feedback.");
      }
    } catch {
      setError("Failed to submit feedback.");
    }
  };

  const handleGoBack = () => {
    navigate("/");
  };

  if (submitted)
    return (
      <div className="thank-you-msg">
        <div>
          Thank you for answering the survey.
          <br />
          <button className="go-back-btn" onClick={handleGoBack}>
            Go back to Login
          </button>
        </div>
      </div>
    );

  return (
    <form onSubmit={handleSubmit} className="feedback-container">
      <h2>Feedback</h2>
      <div className="question-card flashcard">
        <div className="feedback-form-group">
          <label htmlFor="name">Name *</label>
          <input
            id="name"
            className="feedback-input"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter your name"
            required
          />
        </div>
        <div className="feedback-form-group">
          <label htmlFor="collegeName">College Name *</label>
          <input
            id="collegeName"
            className="feedback-input"
            type="text"
            value={collegeName}
            onChange={(e) => setCollegeName(e.target.value)}
            placeholder="Enter your college name"
            required
          />
        </div>
        <div className="feedback-form-group">
          <label htmlFor="companyName">Company Name (optional)</label>
          <input
            id="companyName"
            className="feedback-input"
            type="text"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="Enter your company's name"
          />
        </div>
        <div className="feedback-form-group">
          <label htmlFor="city">City *</label>
          <input
            id="city"
            className="feedback-input"
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="Enter your city"
            required
          />
        </div>
        <div className="feedback-form-group">
          <label htmlFor="streamOfEngineering">Stream of Engineering *</label>
          <input
            id="streamOfEngineering"
            className="feedback-input"
            type="text"
            value={streamOfEngineering}
            onChange={(e) => setStreamOfEngineering(e.target.value)}
            placeholder="Enter your engineering stream"
            required
          />
        </div>
        <div className="feedback-form-group">
          <label htmlFor="feedback">Feedback *</label>
          <textarea
            id="feedback"
            className="feedback-textarea"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Enter your feedback here..."
            rows={4}
            required
            style={{
              width: "100%",
              borderRadius: 8,
              padding: 8,
              border: "1.5px solid #a7c957",
            }}
          />
        </div>
        {error && <div className="feedback-error">{error}</div>}
      </div>
      <div className="flashcard-controls">
        <button type="submit" className="submit-btn">
          Submit
        </button>
      </div>
    </form>
  );
};

export default FeedbackPage;
